module.exports = __webpack_public_path__ + "media/offer_vehicles/przyczepa@3x-84ccb9a4.svg";